module.exports = __webpack_public_path__ + "img/logo.0a951e98.png";